import styled from 'styled-components';

export default styled.div`
  margin: 0 !important;
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
`;
